export const jobRoles = ["admin", "super_admin", "supervisor", "agent", "sales_dealer"];
export const canUseJobs = user => !!user?.id && jobRoles.includes(user.role) && !user.support_mode &&
  user.is_active !== false && user.disabled !== true &&
  !["INACTIVE", "DISABLED", "SUSPENDED", "DELETED", "CLOSED"].includes(String(user.status || "").trim().toUpperCase());

export const activeStatuses = ["UPLOADING", "QUEUED", "RUNNING"];
export const terminalStatuses = ["COMPLETED", "PARTIAL", "FAILED", "NEEDS_REVIEW", "CANCELLED"];
export const jobLabels = { UPLOADING: "Saving upload", QUEUED: "Queued", RUNNING: "Running", COMPLETED: "Completed",
  PARTIAL: "Completed with errors", FAILED: "Failed", NEEDS_REVIEW: "Needs review", CANCELLED: "Cancelled" };
export const RECENT_JOB_MS = 24 * 60 * 60 * 1000;

export function isRecentJob(job, now) {
  if (activeStatuses.includes(job.status)) return true;
  const finished = Date.parse(job.completed_at || job.updated_at || "");
  return Number.isFinite(finished) && now < finished + RECENT_JOB_MS;
}
